import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';

type Props = Omit<IconButtonProps, 'color'>;

const ThemableIconButton: React.FC<Props> = (props: Props): JSX.Element => {
  const { size = 'large', ...restProps } = props;
  return <IconButton color="secondary" size={size} {...restProps} />;
};

export default ThemableIconButton;
